import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

// ================= AES KEY =================
export const generateAESKey = () => {
  return CryptoJS.lib.WordArray.random(32); // 256-bit
};

// ================= IV =================
export const generateIV = () => {
  return CryptoJS.lib.WordArray.random(16);
};

// ================= AES ENCRYPT =================
export const encryptAES = (plainText, aesKey, iv) => {
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    aesKey,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const combined = iv.concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
};

// ================= AES DECRYPT =================
export const decryptAES = (encryptedBase64, aesKey) => {
  const data = CryptoJS.enc.Base64.parse(encryptedBase64);

  // const aesBase64 = CryptoJS.enc.Base64.parse(aesKey);

  // ✅ FIXED IV extraction
  const iv = CryptoJS.lib.WordArray.create(data.words.slice(0, 4), 16);

  const ciphertext = CryptoJS.lib.WordArray.create(
    data.words.slice(4),
    data.sigBytes - 16
  );

  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, aesKey, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
  //return CryptoJS.enc.Utf8.stringify(decrypted);
};

// ================= RSA ENCRYPT AES KEY =================
export const encryptAESKeyRSA = (publicKeyPEM, aesKeyBase64) => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKeyPEM);

  const encrypted = encryptor.encrypt(aesKeyBase64.trim());

  if (!encrypted) {
    throw new Error("RSA Encryption Failed");
  }

  return encrypted; // Base64
};

// ================= SIGNATURE =================
export const generateSignature = (
  method,
  apiKey,
  date,
  payloadMD5,
  apiSecret
) => {
  const rawData = method + apiKey + date + payloadMD5;

  return CryptoJS.HmacSHA1(rawData, apiSecret).toString(CryptoJS.enc.Hex);
};
